// 8-byte game input packet. Must match backend/wire/input.go.

export const InputPacketBytes = 8

export const InputThrust      = 1 << 0
export const InputRotateLeft  = 1 << 1
export const InputRotateRight = 1 << 2

// InputPacket shape:
//   { flags: number, fireCount: number, activateCount: number }

export function encodeInput(p) {
  const buf = new ArrayBuffer(InputPacketBytes)
  const view = new DataView(buf)
  view.setUint32(0, p.flags >>> 0, true)
  view.setUint16(4, p.fireCount & 0xffff, true)
  view.setUint16(6, p.activateCount & 0xffff, true)
  return buf
}

// Decodes an 8-byte input packet from `view` at `offset`. Returns an object
// with { flags, fireCount, activateCount }. Used by tests; the game itself
// never decodes input packets (it only sends them).
export function decodeInput(view, offset) {
  return {
    flags: view.getUint32(offset, true),
    fireCount: view.getUint16(offset + 4, true),
    activateCount: view.getUint16(offset + 6, true),
  }
}
